module.exports = __webpack_public_path__ + "menu_3_active_pc.7e8c7298.png";